import React, { Component } from 'react'
import styled from 'styled-components'
import { injectState } from 'freactal'
import {
  serializeContentSection,
  deserializeContentSection,
  serializeTasks,
  deserializeTasks,
} from '../../../lib'
import { Prompt } from 'react-router-dom'
import { Textfield, Switch, IconButton } from 'react-mdl'
import Panel from '../../components/Panel'
import Editor from '../../../components/Editor'
import DisplayError from '../../../components/DisplayError'
import MappingDialog from '../../components/MappingDialog'
import SavingIndicator from '../../../components/SavingIndicator'
import Button from '../../../components/Button'
import TasksTable from './TasksTable'
const Textarea = styled.textarea`width: 100%;`
const Saving = styled.div`
  position: absolute;
  top: 0.25em;
  right: 0.25em;
`
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 5px;
`

class SummativePracticalAssessmentPanel extends Component {
  state = this.getInitialState(this.props.summativePractical)
  componentWillReceiveProps({ summativePractical }) {
    if (summativePractical !== this.props.summativePractical) {
      this.setState(this.getInitialState(summativePractical))
    }
  }
  getInitialState({
    _id,
    name,
    mapping = [],
    introduction,
    scenario,
    tasks = [],
    checklistHeaders,
    learnerGuideContent,
  }) {
    return {
      _id,
      saved: true,
      name,
      mapping,
      introduction: deserializeContentSection(introduction),
      hasScenario: !!scenario,
      scenarioIntroduction: scenario && scenario.introduction,
      scenarioItems: scenario && scenario.items,
      tasks: deserializeTasks(tasks),
      checklistHeaders,
      learnerGuideContent: deserializeContentSection(learnerGuideContent),
      editingMapping: false,
    }
  }
  toggleScenario = () =>
    this.setState(({ hasScenario, scenarioIntroduction, scenarioItems }) => ({
      saved: false,
      hasScenario: !hasScenario,
      scenarioIntroduction: scenarioIntroduction || '',
      scenarioItems: scenarioItems || [],
    }))
  handleChangeName = ({ target }) => {
    this.setState({ saved: false, name: target.value })
  }
  handleChangeIntroduction = introduction => {
    this.setState({ saved: false, introduction })
  }
  handleChangelearnerGuideContent = learnerGuideContent => {
    this.setState({ saved: false, learnerGuideContent })
  }
  handleChangeChecklistHeaders = ({ target }) => {
    this.setState({
      saved: false,
      checklistHeaders: target.value.split(', '),
    })
  }
  handleChangeScenarioIntroduction = ({ target }) => {
    this.setState({ saved: false, scenarioIntroduction: target.value })
  }
  handleChangeScenarioItems = ({ target }) => {
    this.setState({
      saved: false,
      scenarioItems: target.value.split('\n').map(row => row.split(', ')),
    })
  }
  handleChangeTasks = tasks => {
    this.setState({ saved: false, tasks })
  }
  saveChanges = () => {
    this.setState({ saved: 'saving' }, async () => {
      const {
        index,
        summativePractical: originalSummativePractical,
      } = this.props
      const {
        name,
        mapping,
        introduction,
        hasScenario,
        scenarioIntroduction,
        scenarioItems,
        tasks,
        checklistHeaders,
        learnerGuideContent,
      } = this.state
      // maintain keys not editted in this screen e.g. assessmentPlan
      const summativePractical = {
        ...originalSummativePractical,
        name,
        mapping,
        introduction: serializeContentSection(introduction),
        ...(hasScenario
          ? {
              scenario: {
                introduction: scenarioIntroduction,
                items: scenarioItems,
              },
            }
          : {}),
        tasks: serializeTasks(tasks),
        checklistHeaders,
        learnerGuideContent: serializeContentSection(learnerGuideContent),
      }
      await this.props.updateSummativePractical(summativePractical, index)
      this.setState({ saved: true })
    })
  }

  duplicateAssessment = () => {
    this.setState({ saved: 'saving' }, async () => {
      const {
        index,
        originalSummativePractical,
      } = this.props
      const {
        name,
        mapping,
        introduction,
        hasScenario,
        scenarioIntroduction,
        scenarioItems,
        tasks,
        checklistHeaders,
        learnerGuideContent,
      } = this.state
      const summativePractical = {
        ...originalSummativePractical,
        name,
        mapping,
        introduction: serializeContentSection(introduction),
        ...(hasScenario
          ? {
              scenario: {
                introduction: scenarioIntroduction,
                items: scenarioItems,
              },
            }
          : {}),
        tasks: serializeTasks(tasks),
        checklistHeaders,
        learnerGuideContent: serializeContentSection(learnerGuideContent),
      }
      summativePractical.name = summativePractical.name + " (COPY)"
      await this.props.copySummativePractical(summativePractical, index)
      this.setState({ saved: true })
    })
  }

  openEditMapping = () =>
    this.setState(({ mapping }) => ({
      // set temp mapping to current mapping
      editingMapping: true,
      pendingMapping: mapping,
    }))
  closeEditMapping = () =>
    this.setState({
      editingMapping: false,
    })
  handleChangeMapping = pendingMapping => this.setState({ pendingMapping })
  saveMapping = async () => {
    // move pending mapping to current mapping
    this.setState(({ pendingMapping }) => ({
      mapping: pendingMapping,
      editingMapping: false,
    }))
    await this.props.updateSummativePracticalMapping(
      this.state.pendingMapping,
      this.props.index,
    )
  }
  render() {
    const {
      _id,
      name,
      mapping,
      saved,
      introduction,
      hasScenario,
      scenarioIntroduction,
      scenarioItems,
      tasks,
      checklistHeaders,
      learnerGuideContent,
      editingMapping,
      pendingMapping,
    } = this.state
    const { state: { updateSummativePracticalAssessmentError } } = this.props
    return (
      <Panel>
        <Saving>
          <SavingIndicator
            saved={saved}
            error={updateSummativePracticalAssessmentError}
          />
        </Saving>
        <DisplayError
          msg="Error while saving"
          error={updateSummativePracticalAssessmentError}
        />
        <Textfield
          floatingLabel
          label="Summative Practical Assessment Name"
          onChange={this.handleChangeName}
          value={name || ''}
          style={{ width: '90%' }}
        />
        <IconButton
          name="map"
          accent
          onClick={this.openEditMapping}
          style={{
            position: 'absolute',
            top: '1em',
            right: '0',
          }}
        />
        <h5>Introduction Text</h5>
        <Editor onChange={this.handleChangeIntroduction} state={introduction} />
        <h5>
          Scenario Builder{' '}
          <Switch onChange={this.toggleScenario} checked={hasScenario} />
        </h5>
        {hasScenario &&
          <div>
            <p>
              Introduction - This is the content that will appear in the first
              column of the scenario table. e.g. 'Elements (circle all that
              apply)'.
            </p>
            <Textarea
              onChange={this.handleChangeScenarioIntroduction}
              value={scenarioIntroduction}
            />
            <p>
              Content - This will appear in the second column of the scenario
              table. e.g. list of elements OR leave blank. Separate all list
              elements with a comma and rows with returns.
            </p>
            <Textarea
              onChange={this.handleChangeScenarioItems}
              value={scenarioItems.map(row => row.join(', ')).join('\n')}
            />
          </div>}
        <h5>Checklist Headers</h5>
        <p>
          These are the header labels for the columns containing checkboxes for
          the assessment checklist. Separate each label with a comma.  Leave blank for Y / N columns
        </p>
        <Textarea
          onChange={this.handleChangeChecklistHeaders}
          value={checklistHeaders.join(', ')}
        />
        <hr />
        <h5>Tasks</h5>
        <p>
          Items without any preceeding characters rendered as a header, # will be a sub-header.  ## at the beginning of a question, which will give Y / N columns.<br/>
          __ (two '_' characters) will render a bullet point which can be under headers, sub-headers or questions.
        </p>
        <TasksTable
          tasks={tasks}
          mappingWhitelist={pendingMapping}
          onChange={this.handleChangeTasks}
        />
        <h5>Learner Practical Assessment</h5>
        <p>
          This will appear at the end of the Learner Guide. It is a summary of
          the practical assessment that they will undertake.
        </p>
        <Editor
          onChange={this.handleChangelearnerGuideContent}
          state={learnerGuideContent}
        />
        <ButtonsContainer>
          <Button
            primary
            raised
            disabled={saved === true}
            onClick={this.saveChanges}>
            Save
          </Button>
          <Button
            secondary
            raised
            onClick={this.duplicateAssessment}>
            Duplicate
          </Button>
          <Button
            raised
            primary
            disabled={tasks.length > 0 || mapping.length > 0}
            onDisabledClick={() =>
              this.props.effects.snackbarAlert(
                'Please remove the mapping and tasks associated with this assessment before deleting.',
              )}
            onClick={async () =>
              await this.props.removeSummativePractical(_id)}>
            Delete Assessment
          </Button>
        </ButtonsContainer>
        <Prompt
          when={saved !== true}
          message={`Unsaved changes in "${name}"`}
        />
        {editingMapping &&
          <MappingDialog
            title={`Mapping for ${name}`}
            goBack={this.closeEditMapping}
            mapping={pendingMapping}
            onChangeMapping={this.handleChangeMapping}
            saveMapping={this.saveMapping}
          />}
      </Panel>
    )
  }
}
export default injectState(SummativePracticalAssessmentPanel)



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/SummativePractical/SummativePracticalAssessmentPanel.js